::ng-deep lib-dac6-cell-decorator{display:flex;flex-grow:1}
/*# sourceMappingURL=dac6-cell-decorator.component-POX5ZRGO.css.map */
